module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.16e1d930cf13fb7a9563.woff";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/assets/vendors/ng-prime/fonts/roboto-v15-latin-regular.woff
// module id = ../../../../../src/assets/vendors/ng-prime/fonts/roboto-v15-latin-regular.woff
// module chunks = 2